import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {LineTypeApiModel} from "./line-type.api-model";

export class LineTypeDomainModel extends BaseDomainModel {
  apiModel: LineTypeApiModel;

  get name(): String {
    return this.apiModel.name;
  }

  get shortName(): String {
    return this.apiModel.shortName;
  }

  get title(): String {
    return this.apiModel.title;
  }

  get internalOptionType(): Number {
    return this.apiModel.internalOptionType;
  }
}